"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, PlayCircle, Star, Ticket, User, Users } from "lucide-react";
import { useTranslations } from "next-intl";

import { cn } from "@/lib/cn";

/** Bottom nav — design.md §1. State aktif: warna primary + titik indikator. */
export function BottomNavClient({ isAuthenticated }: { isAuthenticated: boolean }) {
  const pathname = usePathname();
  const t = useTranslations("BottomNav");

  const NAV = [
    { href: "/beranda", label: t("beranda"), Icon: Home },
    { href: "/tiket", label: t("tiket"), Icon: Ticket },
    { href: "/komunitas", label: t("komunitas"), Icon: Users },
    { href: "/vod", label: t("vod"), Icon: PlayCircle },
    isAuthenticated
      ? { href: "/profil", label: t("profil"), Icon: User }
      : { href: "/membership", label: t("membership"), Icon: Star },
  ];

  return (
    <nav className="bg-surface-base fixed inset-x-0 bottom-0 z-50 mx-auto max-w-lg rounded-t-2xl border-t border-outline-variant/10 shadow-[0_-8px_30px_rgb(241,102,6,0.08)]">
      <div className="flex h-16 items-center justify-around px-container-margin pb-safe">
        {NAV.map(({ href, label, Icon }) => {
          const active = pathname.startsWith(href);
          return (
            <Link
              key={href}
              href={href}
              aria-current={active ? "page" : undefined}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 transition-transform active:scale-90",
                active ? "text-primary" : "text-on-surface-variant hover:text-primary",
              )}
            >
              <Icon className="size-6" strokeWidth={active ? 2.5 : 2} aria-hidden />
              <span className="font-label text-label-caps">{label}</span>
              <span
                className={cn(
                  "size-1 rounded-full",
                  active ? "bg-primary-container" : "bg-transparent",
                )}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
